export const GANTT_MONTH_LABELS = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
] as const;

/** Atributo que liga o tooltip do Gantt a qualquer elemento do conteúdo (texto em `data-pr-tooltip`). */
export const GANTT_TOOLTIP_ATTRIBUTE = "data-gantt-tip";

export const GANTT_ACTIONS_LABEL = "Ações";
export const GANTT_EXPAND_LABEL = "Expandir";
export const GANTT_COLLAPSE_LABEL = "Recolher";
